import { Component, Inject, Input, OnInit } from '@angular/core';
import { VerificationSessionsService } from '../../services/verification.service';
import { VerificationSession } from '../../models/verification-session.model';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Environment } from 'src/app/models/environment.model';

@Component({
  standalone: false,
  selector: 'sa-verification-session-inline',
  templateUrl: './verification-session-inline.component.html',
  styleUrls: ['./verification-session-inline.component.scss']
})
export class VerificationSessionInlineComponent implements OnInit {

  isLoading = true;
  hasError = false;
  isImageLoading = false;
  hasImageError = false;

  @Input()
  verificationSessionId: string;

  verificationSession: VerificationSession;

  constructor(
    private verificationSessionsService: VerificationSessionsService,
    @Inject('environment') private environment: Environment,
  ) { }

  ngOnInit(): void {
    this.verificationSessionsService.getVerificationSession(this.verificationSessionId).pipe(
      tap(verificationSession => {
        this.isLoading = false;
        this.verificationSession = verificationSession;
      }),
      catchError(() => {
        this.isLoading = false;
        this.hasError = true;
        return of();
      })
    ).subscribe();
  }

  onSeeImageClicked() {
    // The endpoint requires an admin token, so window.open() on the raw URL
    // 401s — a new tab sends no Authorization header. Fetch it through
    // HttpClient (the token interceptor adds the header) and open the blob.
    this.isImageLoading = true;
    this.verificationSessionsService.getVerificationSessionRefImage(this.verificationSession.id).pipe(
      tap(blob => {
        this.isImageLoading = false;
        const objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl, '_blank');
        // Give the new tab time to load before dropping our handle on the blob.
        setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
      }),
      catchError(() => {
        this.isImageLoading = false;
        this.hasImageError = true;
        return of();
      }),
    ).subscribe();
  }
}
